export const toTitleCase = (value: string) => {
  if (!value) return value;
  return value
    .toLowerCase()
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
